import React from "react";
import "./Why_Stands_Out.css";

function Why_Stands_Out() {
  const features = [
    {
      title: "Dynamic Advertising",
      description:
        "The vivid HD screens and engaging content grab the audience’s attention, unlike static billboards or banners.",
    },
    {
      title: "Real-Time Updates",
      description:
        "Ads can be updated easily, allowing for timely promotions, seasonal offers, or campaign modifications.",
    },
    {
      title: "Consistency Across Locations",
      description:
        "The uniformity of branding at multiple bus stands strengthens your brand identity.",
    },
    {
      title: "Eco-Friendly Solution",
      description:
        "Digital screens reduce the need for physical advertising materials, making it a sustainable choice for businesses.",
    },
  ];

  return (
    <>
      <section className="Why_Stands_Out">
        <div className="container">
          <div className="Heading-holder">
            <h1>Why Videowala Bus Stand Stands Out</h1>
          </div>

          <div className="Why_Stands_Out_list_holder">
            <div className="row justify-content-center">
              {features.map((feature, index) => (
                <div className="col-xl-5 col-md-6" key={index}>
                  <div className="Why_Stands_Out_list_holder_card mb-5">
                    <div className="row ">
                      <div className="col-md-1 col-1">
                        <div className="dot-holder"></div>
                      </div>
                      <div className="col-md-11 col-11">
                        <div className="text-holder">
                          <div className="list-heading-holder">
                            <h4>{feature.title}</h4>
                          </div>

                          <div className="list-text-holder">
                            <p>{feature.description}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="right_side_img_holder">
            <img
              src="/Assets/Images/Service/Services/Video_Wala_Bus_Stand/why_video_wala/Mask Group 820.png"
              className="inner_img"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Why_Stands_Out;
